import { CONST } from "../../CONST";
import { BurgerScene } from "../../scenes/BurgerScene";
import { Ingredient } from "./Ingredient";


const CONFIG = {
    position: {x: 427, y: 240},
    maxIngredientDistance: 90, //Whats the max distance where ingredient drop still counts as added to burger 
    nextIngredientPositionChange: {x: 0, y: -15},

    containerDepth: 10,


    interactive: {
        heightPerIngredient: 15,
        defaultHeight: 40,
    }
}

export class BurgerManager {
    private scene : BurgerScene;

    private burgerContainer !: Phaser.GameObjects.Container;
    private currentIngredients : Ingredient[] = [];

    private nextIngredientPosition !: {x: number, y: number};

    private moveTween !: Phaser.Tweens.Tween;
    public isDragging = false;


    constructor(scene: BurgerScene){
        this.scene = scene;

        this.resetBurger();
    }

    public addIngredient(ingredient: Ingredient){
        this.burgerContainer.add([ingredient.imgShadow, ingredient]);

        ingredient.addToBurger(this.burgerContainer, this.nextIngredientPosition, this.currentIngredients.length === 0);
        this.currentIngredients.push(ingredient);


        this.nextIngredientPosition.y -= ingredient.config.height;

        this.burgerContainer.disableInteractive();
        this.burgerContainer.setInteractive({
            hitArea: new Phaser.Geom.Rectangle(-ingredient.displayWidth/2, -ingredient.displayHeight/2, ingredient.displayWidth , this.currentIngredients[0].displayHeight + this.currentIngredients.length * CONFIG.interactive.heightPerIngredient),
            hitAreaCallback:Phaser.Geom.Rectangle.Contains,
            useHandCursor: true, 
            draggable: true, 
        });

        this.scene.onIngredientAdded(this.currentIngredients.length);
    }

    public serve(){
        this.serveAnimation();

        this.resetBurger();
    }

    public recycle(){
        this.recycleAnimation();

        this.resetBurger();
    }

    //check if coordinates are within adding distance
    public isInRange(x: number, y: number) : boolean{
        return Phaser.Math.Distance.Between(x, y, CONFIG.position.x + this.nextIngredientPosition.x, CONFIG.position.y + this.nextIngredientPosition.y) < CONFIG.maxIngredientDistance;
    }

    public getCurrentIngredientTypes(){
        return this.currentIngredients.map((val) => val.getIngredientType());
    }

    private resetBurger(){
        //Resets the burger state
        this.burgerContainer = this.scene.add.container(CONFIG.position.x, CONFIG.position.y).setDepth(CONFIG.containerDepth);

        this.burgerContainer.on('dragstart', (pointer: any, dragX: number, dragY: number) => {
            this.isDragging = true;
            this.handleDragStart();
         });
    
         this.burgerContainer.on('drag', (pointer: any, dragX: number, dragY: number) => {
            if (!this.isDragging) return;
            this.handleDrag(dragX, dragY);
        });
   
        this.burgerContainer.on('dragend', (pointer: any, dragX: number, dragY: number, dropped: boolean) => {
            this.isDragging = false;
            this.handleDragEnd();
        });

        this.nextIngredientPosition  = {x: 0, y: 0};

        this.currentIngredients = [];
    }

    private handleDragStart(){
        this.scene.onIngredientDrag(true);
        this.scene.sound.play(CONST.AUDIO.GRAB, {detune: this.scene.getDetune()});
    }

    private handleDrag(x: number, y: number){
        this.burgerContainer.setPosition(x, y);
    }

    private handleDragEnd(){
        this.scene.onIngredientDrag(false);
        this.scene.sound.play(CONST.AUDIO.GRAB, {detune: this.scene.getDetune()});

        //check for serve/recycle
        if (this.moveTween){
            this.moveTween.stop();
        }

        this.moveTween = this.scene.tweens.add({
            targets: this.burgerContainer, 
            x: CONFIG.position.x,
            y: CONFIG.position.y, 
            duration: 500,
            ease: "Quad.easeOut",
        });
    }

    private serveAnimation(){
        let target = this.burgerContainer;
        this.scene.tweens.add({
            targets: this.burgerContainer,
            y: "-=315",
            duration: 500,
            delay: 700,
            ease: "Back.easeInOut",
            onComplete: () => {target.destroy()}
        });
    }

    private recycleAnimation(){
        let target = this.burgerContainer;
        this.scene.tweens.add({
            targets: this.burgerContainer,
            y: "+=700",
            duration: 500,
            delay: 500,
            ease: "Back.easeIn",
            onComplete: () => {target.destroy()}
        });
    }

    public getBurgerPosition(){
        return {x: this.burgerContainer.x, y: this.burgerContainer.y};
    }

    public isBurgerDragging(){
        return this.isDragging;
    }
}